import api from "../services/api";

// Prepaid wallet (main server :5001)
export const getWallet = () => api.get("/api/wallet");

export const getWalletTransactions = (params = {}) =>
  api.get("/api/wallet/transactions", { params });

export const getWalletTransaction = (id) =>
  api.get(`/api/wallet/transactions/${id}`);

export const getWalletSpendSummary = (params = {}) =>
  api.get("/api/wallet/spend/summary", { params });

export const getWalletCampaignSpend = (campaignId, params = {}) =>
  api.get(`/api/wallet/spend/campaigns/${campaignId}`, { params });

export const getMyPrices = (country = "IN") =>
  api.get("/api/wallet/prices", { params: { country } });

// Service (session) message usage per WhatsApp number — monthly free
// allowance, then billed at the utility rate (Meta change, 1 Oct 2026).
export const getServiceUsage = (month) =>
  api.get("/api/wallet/service-usage", { params: month ? { month } : {} });

export const updateWalletSettings = (payload) =>
  api.patch("/api/wallet/settings", payload);

export const estimateSendCost = (category, phones) =>
  api.post("/api/wallet/estimate", { category, phones });

export const createRechargeOrder = (amount) =>
  api.post("/api/wallet/recharge/order", { amount });

export const verifyRecharge = (paymentData) =>
  api.post("/api/wallet/recharge/verify", paymentData);
